import React from "react";
import BaksoTigerGame from "./BaksoTigerGame";
import "./styles.css";

export default function App() {
  return <BaksoTigerGame />;
  }